import { Component } from '@angular/core';

@Component({
  selector: 'kbxl-load-board',
  template: '<router-outlet></router-outlet>',
})
export class LoadBoardComponent {}
